import { BodyText, Heading, Icon, IconSet } from '@postscript/components';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { useState } from 'react';

import classes from './WorkflowAside.module.css';

interface AccordionProps {
  title: string;
  content: string;
  icon: keyof typeof IconSet;
}

export const WorkflowAside = ({ title, content, icon }: AccordionProps) => {
  const isReducedMotion = useReducedMotion();

  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className={classes.accordion}>
      <button
        type="button"
        className={classes.header}
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
        aria-controls="accordion-content"
      >
        <Icon component={IconSet[icon]} size="large" />

        <Heading size="xx-small">{title}</Heading>

        <Icon
          component={IconSet[isOpen ? 'ChevronUp' : 'ChevronDown']}
          size="large"
        />
      </button>

      <AnimatePresence initial={false}>
        {isOpen && (
          <motion.div
            id="accordion-content"
            className={classes.content}
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{
              duration: isReducedMotion ? 0 : 0.3,
              ease: 'easeInOut',
            }}
          >
            <BodyText size="medium">{content}</BodyText>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};
